import script from "./TransferChangeLightControllerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferChangeLightControllerPage.vue?vue&type=script&setup=true&lang=js"

import "./TransferChangeLightControllerPage.vue?vue&type=style&index=0&id=2576f980&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2576f980"]])

export default __exports__